import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { authService } from "../../services/auth.service";
import { accountsDetails } from "../../actions/home.action"
import { routePaths } from "../config/route-paths";
import { config } from "../../enviroment";
import SimpleModal from './model';

export const TabsContext = React.createContext();
export default function DataRefresh(props) {
  const dispatch = useDispatch()
  const [open, setOpen] = React.useState(false);
  const [selectedacc,setselectedacc]=React.useState(false);
  const [accountList, setaccountList] = React.useState();
  const [error, setError] = React.useState(false);
  const [dropdownList, setdropdownList] = useState()
  const [delaccount, setdelaccount] = useState()
  const [localStorageupdate,setlocalStorageupdate]= useState()
  let interval = Number(config.constants.UPDATE_ACCOUNT_DETAILS_TTL) ? config.constants.UPDATE_ACCOUNT_DETAILS_TTL : config.constants.ACCOUNT_DETAILS_DEFAULT_TTL;
  let refreshsucess = localStorage.getItem("refreshsucess")
  let accountSelected = localStorage.getItem("accountSelected")
  let accountDropdown = localStorage.getItem("firstLogin")
  let bearer = JSON.parse(localStorage.getItem("bearer"));
  let accountListData = useSelector(
    (store) =>
      store?.accountInformation?.personAcccountDetail?.personAccountList
  );
  const apicall = () => {
    if (!(window.location.pathname == routePaths.ALERTS_AND_NOTIFICATION || window.location.pathname == routePaths.SELF_HELP)) {
      authService.accountDetaisAfterLogin().then(accountInformation => {
        let bearer = JSON.parse(localStorage.getItem("bearer"));
        let { email, lastFourDigitsOfPhoneNumber, userName, ...accountInformationData } = accountInformation
        bearer.email = email
        bearer.lastFourDigitsOfPhoneNumber = lastFourDigitsOfPhoneNumber
       //  bearer.userName = userName
        bearer.accountDetails = accountInformationData
        localStorage.setItem("bearer", JSON.stringify(bearer)
        );
        dispatch(accountsDetails())
      }).catch(accountInfoError => {
        if (accountInfoError.toString().includes("403")) {
          setError(true);
        }
        throw (accountInfoError)
      })
    }
  }

  // useEffect(() => {
  //   setInterval(() => {
  //     if (!(window.location.pathname == routePaths.ALERTS_AND_NOTIFICATION || window.location.pathname == routePaths.SELF_HELP)) {
  //       apicall()
  //     }
  //   }, interval)
  // }, [interval])

  useEffect(() => {
    if (error && refreshsucess) {
      if (!(window.location.pathname == routePaths.ALERTS_AND_NOTIFICATION || window.location.pathname == routePaths.SELF_HELP)) {
        apicall()
      }
    }
  }, [error && refreshsucess])

  useEffect(() => {
    let accountList = []
    if (accountListData?.length) {
      accountListData.filter((item) => {
        if ((item.accountSaList.length > 0)) {
          accountList.push(item)
        }
      })
    }
    setaccountList(accountList)
  }, [accountListData, accountSelected])

  useEffect(() => {
    if (accountList?.length ) {
      let dropdownList = accountList.map((item) => item.customerNumber);
      setdropdownList(dropdownList)
    } 
    if(accountList && accountDropdown!='true'){
      let dropdownList = accountList.map((item) => item.customerNumber);
      let accountdel = accountList.map((item) => item.customerNumber)?.length && JSON.parse(accountDropdown)?.length && (accountList.map((item) => item.customerNumber)?.length == JSON.parse(accountDropdown)?.length)
     let selectedaccountdel=dropdownList&& bearer && dropdownList.find((item)=>item==accountSelected)
      setdelaccount(JSON.parse(accountDropdown)?.filter((item) => dropdownList.indexOf(item) == -1))
      if(bearer){
        if (selectedaccountdel == undefined) {
          setOpen(true);
          setselectedacc(true)
        }else if(!accountdel && accountdel != undefined){
          setOpen(true)
          setselectedacc(false)
        } else  {
          setOpen(false)
        }
      }
    }
  }, [accountSelected, accountList, accountDropdown])

  useEffect(() => {
    if (dropdownList?.length && accountDropdown == "true") {
      localStorage.setItem("firstLogin", JSON.stringify(dropdownList))
    }else if(dropdownList?.length && localStorageupdate ){
      localStorage.setItem("firstLogin", JSON.stringify(dropdownList))
      setOpen(false)
    }
  }, [dropdownList && accountDropdown,localStorageupdate])

  return (
    <TabsContext.Provider
    value={{ setlocalStorageupdate,localStorageupdate }}
  >
      {/* <SimpleModal open={open} delaccount={delaccount} selectedacc={selectedacc}/> */}
      </TabsContext.Provider>

  );
}
